import ClientProspectForm from './components/ClientCommercial/ClientProspectForm/ClientProspectForm.vue'
import AccountOptions from './components/Core/Account/AccountOptions.vue'
import AccountPage from './components/Core/Account/AccountPage.vue'
import AccountWelcomePage from './components/Core/Account/WelcomeAccountPage.vue'
import AccountSignaturePage from './components/Core/Account/AccountSignaturePage.vue'
import AdminClientsOptions from './components/AdminClients/AdminClientsPageOptions.vue'
import AdminClientsPage from './components/AdminClients/AdminClientsPage.vue'
import AdminClientsWelcome from './components/AdminClients/Welcome/AdminClientsWelcome.vue'
import AdministrativeMenu from './components/Administrative/AdministrativeMenu.vue'
import AdministrativePage from './components/Administrative/AdministrativePage.vue'
import AdministrativePageWelcome from './components/Administrative/AdmnistrativePageWelcome/AdministrativePageWelcome.vue'
import AdminOptions from './components/Admin/AdminPage/AdminOptions.vue'
import AdminPage from './components/Admin/AdminPage/AdminPage.vue'
import AdminWelcomePage from './components/Admin/AdminPage/WelcomePage.vue'
import AdoptionReportPage from './components/Reporting/Company/Adoption/AdoptionReportPage.vue'
import AlertNotificationsPage from './components/Admin/AlertNotifications/AlertNotificationsPage.vue'
import App from './components/App.vue'
import ApprovalDutiesPage from './components/Administrative/Duties/ApprovalDutiesPage.vue'
import AssignationsPage from './components/Admin/AssignationsPage/AssignationsPage.vue'
import AssignedPetitionsList from './components/ClientService/AssignedPetitions/AssignedPetitionsList.vue'
import AssignedTaskPage from './components/Administrative/Tasks/AssignedTasks/AssignedTasksPage.vue'
import AssignmentDutiesPage from './components/Administrative/Duties/AssignmentToTheClient/AssignmentDutiesPage.vue'
import AssignmentTaskPage from './components/Administrative/Tasks/AssignmentTask/AssignmentTaskPage.vue'
import AssignToolToTheClientPage from './components/Logistics/AssignToolToTheClient/AssignToolToTheClientPage.vue'
import AuthorizeEntryPerson from './components/Vigilance/AuthorizeEntry/AuthorizeEntryPerson.vue'
import AuthorizeEntryPersonList from './components/Vigilance/AuthorizeEntry/AuthorizeEntryPersonList.vue'
import CameraPage from './components/Tests/CameraPage.vue'
import ChangePassword from './components/Admin/ChangePassword/ChangePasswordPage.vue'
import ClientConfigOptions from './components/Admin/Client/ClientConfigPage/ClientConfigOptions.vue'
import ClientConfigPage from './components/Admin/Client/ClientConfigPage/ClientConfigPage.vue'
import ClientContactsPage from './components/Clients/ClientContacts/ClientContactsPage.vue'
import ClientDashboardPage from './components/Reporting/Company/ClientDashboard/ClientDashboardPage.vue'
import ClientForm from './components/Clients/ClientForm/ClientForm.vue'
import ClientMailReview from './components/Administrative/ClientMailReview/ClientMailReview'
import ClientReportingPage from './components/Reporting/Client/ClientReportingPage.vue'
import ClientSelectionPage from './components/Auth/LoginPage/ClientSelection/ClientSelectionPage.vue'
import ClientsList from './components/Clients/ClientsList/ClientsList.vue'
import ClientsMailsPage from './components/Admin/ClientsMails/ClientsMailsPage.vue'
import ClientsNotebookPage from './components/Admin/ClientsNotebook/ClientsNotebookPage.vue'
import ClientsVisitorsPage from './components/Admin/ClientsVisitors/ClientsVisitorsPage.vue'
import CompanyReportingPage from './components/Reporting/Company/CompanyReportingPage.vue'
import ContactForm from './components/Clients/ClientContacts/Contacts/ContactForm/ContactForm.vue'
// import ContactReportForm from './components/Clients/ClientContacts/ContactReports/ContactReportForm/ContactReportForm.vue';
import NewContactReportPage from './components/Clients/ClientContacts/ContactReports/NewContactReportPage/NewContactReportPage'

import CreatedTasksResolvedPage from './components/Administrative/Tasks/CreatedTasksResolved/CreatedTasksResolvedPage.vue'
import DashboardPage from './components/Reporting/Client/Dashboard/DashboardPage.vue'
// import DeparturesPage from './components/Vigilance/AccessControl/Departures/DeparturesPage.vue';
import DeparturesPage from './components/Vigilance/AccessControl/Departures/DeparturesPageV2.vue'
import DutiesListPage from './components/Admin/Duties/DutiesList.vue'
import DutiesListVigilancePage from './components/Vigilance/Duties/DutiesListVigilancePage.vue'
import EntryPage from './components/Vigilance/AccessControl/Entry/EntryPage.vue'
import EntryTimesPage from './components/Admin/Client/EntryTimesPage/EntryTimesPage.vue'
import FormatsPage from './components/Logistics/Formats/FormatsPage.vue'
import FormatCreate from './components/Logistics/Formats/FormatAdmin/FormatCreate.vue'
import FormatDetailList from './components/Logistics/Formats/FormatDetailList.vue'
import FormatDetail from './components/Logistics/Formats/FormatDetail.vue'
import FormatRegister from './components/Logistics/Formats/FormatRegister.vue'
import GeneralStatusPage from './components/Auth/GeneralStatusPage/GeneralStatusPage.vue'
import GuardianManual from './components/Vigilance/GuardianManual/GuardianManual.vue'
import InternalManagementPage from './components/Reporting/Company/InternalManagement/InternalManagement.vue'
import ItemsPage from './components/Logistics/Items/ItemsPage.vue'
import OperationPage from './components/Operation/OperationPage.vue'
import OperationOptions from './components/Operation/OperationOptions.vue'
import QuotationsPage from './components/Operation/Quotations/QuotationsPage.vue'
import QuotationCreatePage from './components/Operation/Quotations/QuotationCreatePage.vue'
import QuotationEditPage from './components/Operation/Quotations/QuotationEditPage.vue'
import QuotationViewPage from './components/Operation/Quotations/QuotationViewPage.vue'
import QuotationHistoryPage from './components/Operation/Quotations/QuotationHistoryPage.vue'
import ItemsQuotationPage from './components/Operation/ItemsQuotation/ItemsQuotationPage.vue'
import QuotationSettingsPage from './components/Operation/QuotationSettings/QuotationSettingsPage.vue'
import KitsPage from './components/Operation/Kits/KitsPage.vue'
import ItemSubTypes from './components/Logistics/ItemSubTypes/ItemSubTypes.vue'
import ItemTypesPage from './components/Logistics/ItemTypes/ItemTypesPage.vue'
import ListPeople from './components/Admin/People/PeoplePage.vue'
import ListPeoplePage from './components/Admin/StructuresPage/ListPeoplePage.vue'
import ListStructuresPage from './components/Admin/StructuresPage/ListStructuresPage.vue'
import ListUsers from './components/Admin/UsersPage/ListUsersPage.vue'
import ListVehiclesPage from './components/Admin/StructuresPage/ListVehiclesPage.vue'
import LoadStructuresPage from './components/Admin/StructuresPage/LoadStructuresPage.vue'
import LoginPage from './components/Auth/LoginPage/LoginPage.vue'
import LogisticsOptions from './components/Logistics/LogisticsOptions.vue'
import LogisticsPage from './components/Logistics/LogisticsPage.vue'
import MailDistribution from './components/Vigilance/Mail/MailPage/ReceiveForm/MailDistribution.vue'
import MailPage from './components/Vigilance/Mail/MailPage/MailPage.vue'
import MenuOptionsPage from './components/Admin/MenuOptions/MenuOptionsPage.vue'
import MonthlyManagementReportPage from './components/Reporting/Company/MonthlyManagementReport/MonthlyManagementReportPage.vue'
import MyTasksList from './components/Administrative/MyTasks/MyTasksList.vue'
import NotebookOfSupervisors from './components/Administrative/SupervisionReview/SupervisionNotebook/NotebookOfSupervisors.vue'
import NoteBookPage from './components/Vigilance/NoteBook/NoteBookPage/NoteBookPage.vue'
import OperationalIdicators from './components/Reporting/Company/OperationalIndicators/OperationalIdicators'
import PendingActivationsPage from './components/AdminClients/UserManager/PendingActivations/PendingActivationPage.vue'
import PeopleForm from './components/Admin/People/PeopleFormPage.vue'
import SecurityManager from './components/Admin/SecurityManager/SecurityManager'
import PersonVisitors from './components/AdminClients/PersonVisitors/PersonVisitors.vue'
import PositionsPage from './components/Admin/Positions/PositionsPage.vue'
import ClientAreasPage from './components/Admin/ClientAreas/ClientAreasPage.vue'
import ClientDataConsentPage from './components/AdminClients/ClientDataConsent/ClientDataConsentPage.vue'
import IncidentRiskTypesPage from './components/Admin/IncidentRiskTypes/IncidentRiskTypesPage.vue'
import ContractorDocumentTypesPage from './components/Admin/ContractorDocumentTypes/ContractorDocumentTypesPage.vue'
import ContractorManagementPage from './components/AdminClients/ContractorManagement/ContractorManagementPage.vue'
import PqrPage from './components/AdminClients/Pqr/PqrPage.vue'
import PqrsReportingPage from './components/Reporting/Company/Pqrs/PqrsReportingPage.vue'
import ReportingPage from './components/Reporting/ReportingPage.vue'
import ResolvedPetitions from './components/Administrative/ResolvedPetitions/ResolvedPetitions.vue'
import ResolvedPetitionsList from './components/ClientService/ResolvedPetitions/ResolvedPetitionsList.vue'
import ResolvedTasksPage from './components/Administrative/Tasks/ResolvedTasks/ResolvedTasksPage.vue'
import RiskAnalysisClient from './components/Clients/RiskAnalysis/RiskAnalysisClient.vue'
import ShiftEndPage from './components/Vigilance/Shifts/ShiftEnd/ShiftEndPage/ShiftEndPage.vue'
import ShiftsHistoryPage from './components/Vigilance/ShiftsHistory/ShiftsHistoryPage.vue'
import ShiftStartPage from './components/Vigilance/Shifts/ShiftStart/ShiftStartPage/ShiftStartPage.vue'
import StructureAccessPage from './components/Auth/StructureAccessPage/StructureAccessPage.vue'
import SupervisionReview from './components/Administrative/SupervisionReview/SupervisionReview'

import TasksToObservePage from './components/Administrative/Tasks/TasksToObserve/TasksToObservePage.vue'
import UnassignedPetitionsList from './components/ClientService/UnassignedPetitions/UnassignedPetitionsList.vue'
import UserPage from './components/Admin/UsersPage/UsersPage.vue'
import vehicleForm from './components/Admin/Vehicles/VehicleFormPage.vue'
import vehiclesPage from './components/Admin/Vehicles/VehiclesPage.vue'
import VehicleVisitors from './components/AdminClients/VehicleVisitors/VehicleVisitors.vue'
import VigilanceOptions from './components/Vigilance/VigilancePage/VigilanceOptions.vue'
import VigilancePage from './components/Vigilance/VigilancePage/VigilancePage.vue'
import VigilantAccess from './components/Admin/VigilantAccess/VigilantAccessPage.vue'
import RestrictedVisitorsPage from './components/Vigilance/AccessControl/RestrictedVisitors/RestrictedVisitorsPage.vue'
import UsersPendingActivationPage from './components/Administrative/UsersPendingActivation/UsersPendingActivationPage.vue'
import LoadAuthorizations from './components/Vigilance/AuthorizeEntry/LoadAuthorizations/LoadAuthorizations.vue'
import SafetyRecommendations from './components/Administrative/SafetyRecommendations/SafetyRecommendations.vue'
import CargoVehicleEntriesPage from './components/Vigilance/AccessControl/Entry/CargoVehicle/CargoVehicleEntriesPage.vue'
import CargoVehicleDeparturesPage from './components/Vigilance/AccessControl/Departures/CargoVehicle/CargoVehicleDeparturesPage.vue'
import OpenTasksPage from './components/Administrative/Tasks/OpenTasks/OpenTasksPage.vue'
import ContactReportsReviewPage from './components/Clients/ClientContacts/ContactReports/ContactReportsReview/ContactReportsReviewPage.vue'
import PetitionsReviewPage from './components/ClientService/PetitionsReview/PetitionsReviewPage.vue'
import TeamPetitionsPage from './components/ClientService/TeamPetitions/TeamPetitionsIndex.vue'
import BroadcastMessagesPage from './components/AdminClients/BroadcastMessages/BroadcastMessages'
import CompanyBroadcastMessage from './components/Administrative/CompanyBroadcastMessage/CompanyBroadcastMessage'
import StoresPage from './components/Advertising/Stores/StoresPage.vue'
import AdminStore from './components/Advertising/Stores/AdminStore/AdminStore.vue'
import BodyguardServicesPage from './components/Vigilance/Bodyguard/BodyguardServices/BodyguardServicesPage.vue'
import ActiveBodyguardServicePage from './components/Vigilance/Bodyguard/ActiveBodyguardServicePage/ActiveBodyguardServicePage.vue'
import NotebookForBodyguards from './components/Vigilance/NoteBook/NotebookForBodyguards/NotebookForBodyguards.vue'
import ClientUsersPage from './components/AdminClients/ClientUsers/ClientUsersPage.vue'
import ContractorPage from './components/Contractor/ContractorPage.vue'
import ContractorOptions from './components/Contractor/ContractorOptions.vue'
import ContractorDocumentsPage from './components/Contractor/ContractorDocuments/ContractorDocumentsPage.vue'
import { store } from './store/store'
import BodyguardPage from '@components/Vigilance/Bodyguard/BodyguardPage/BodyguardPage'
import BodyguardServiceAdminClient from './components/AdminClients/BodyguardService/BodyguardServiceAdminClient'
import BodyguardServicesAdministrative from './components/Administrative/BodyguardServices/BodyguardServicesAdministrative'
import ManagementIndicators from './components/Reporting/Company/ManagementIndicators/ManagementIndicators'
import RoundsPage from './components/Vigilance/Rounds/RoundsPage'
import DocumentationPage from './components/Documentation/DocumentationPage'
import RoundsReportPage from './components/Vigilance/Rounds/RoundsReportPage/RoundsReportPage'
import ManagementIndicatorsIndex from './components/Reporting/Company/ManagementIndicators/ManagementIndicatorsIndex'
import fileManagementPage from './components/AdminClients/FileManagement/FileManagementPage'

// Modulo de supervision
import SupervisionIndexPage from './components/Supervision/SupervisionIndexPage.vue'
import SupervisionPage from './components/Supervision/SupervisionPage.vue'
import SupervisionChecklist from './components/Supervision/SupervisionChecklist/SupervisionChecklist'
import SupervisionSafetyRecommendation from './components/Supervision/SupervisionSafetyRecommendation/SupervisionSafetyRecommendation'
import SupervisionToolsRevision from './components/Supervision/SupervisionToolsRevision/SupervisionToolsRevision'
import SupervisionNotebook from './components/Supervision/SupervisionNotebook/SupervisionNotebook'
import SupervisionContactReport from './components/Supervision/SupervisionContactReport/SupervisionContactReport'
import SupervisionOldVersionNotice from './components/Supervision/SupervisionOldVersionNotice/SupervisionOldVersionNotice'
import SupervisionSimulations from './components/Supervision/SupervisionSimulations/SupervisionSimulations'
import SupervisionCameraReview from './components/Supervision/SupervisionCameraReview/SupervisionCameraReview.vue'
import SupervisionVehicleStates from './components/Supervision/SupervisionVehicleStates/SupervisionVehicleStates'

// Support
import SupportPage from './components/Support/SupportPage'
import TicketsPage from './components/Support/TicketsPage'
import MyTicketsPage from './components/Support/MyTicketsPage'
import AttentionPage from './components/Support/AttentionPage'

// Reports
import SatisfactionReport from './components/Reporting/Company/Satisfaction/SatisfactionReport'
import ClientsImplementationReport from './components/Reporting/Company/Adoption/Implementation/ClientsImplementationReport'

import ComunicationsModule from './components/Comunications/ComunicationsModule'
import ServiceSpotMessagesPage from './components/Comunications/ServiceSpotMessages/ServiceSpotMessagesPage'
import ServiceSpotMessagesSendPage from './components/Comunications/ServiceSpotMessages/ServiceSpotMessagesSendPage'

import PetPage from './components/Clients/Pets/PetPage'
import RoundsReviewPage from './components/Reporting/Company/Rounds/RoundsReviewPage'

// Management Dashboards
import ManagementDashboardsModule from './components/Reporting/Company/ManagementDashboards/ManagementDashboardsModule.vue'
import SupervisionChecklistDashboard from './components/Reporting/Company/ManagementDashboards/Supervisors/SupervisionChecklistDashboard.vue'
import ManagementIndicatorsDashboard from './components/Reporting/Company/ManagementDashboards/Managers/index.vue'

// Protocols
import ProtocolsModule from './components/Protocols/ProtocolsModule'
import Covid19 from './components/Protocols/Covid19'

// Quality
import QualityModule from './components/Quality/QualityModule'
import ProcessesPage from './components/Quality/ProcessesPage'
import DocumentTypesPage from './components/Quality/DocumentTypesPage'
import DocumentsPage from './components/Quality/DocumentsPage'
// const QualityModule = () => import('./components/Quality/QualityModule')
// const ProcessesPage = () => import('./components/Quality/ProcessesPage')

import ClientMailsReview from './components/Vigilance/Mail/Client/MailIndex'
import PerformanceEvaluationPage from './components/Administrative/PerformanceEvaluation/PerformanceEvaluationPage'

//pagina de evaluaciones de desempeño abiertas
import OpenPerformanceEvaluationPage from './components/Administrative/PerformanceEvaluation/OpenEvaluations/OpenPerformanceEvaluationPage'

//pagina con formulario donde los lideres evaluan a las personas a cargo
import EvaluationPage from './components/Administrative/PerformanceEvaluation/EvaluationPage'

//pagina donde cada administrativo puede ver sus resultados de evaluaciones y diligenciar sus compromisos
import MyEvaluationsPage from './components/Administrative/PerformanceEvaluation/MyEvaluations/MyEvaluationsPage'

//pagina donde se crea y asignan jefes y subordinados del modulo operativo
import PerformanceEvaluationOperativePage from './components/Operative/PerformanceEvaluationOperativePage'

//pagina donde el cliente administrador podra ver los documentos de riesgos subidos por el administrativo
import RiskDiagnosisDocumentationPage from './components/AdminClients/Documents/RiskDiagnosis/RiskDiagnosisDocumentPage'
import DoorsManager from './components/Vigilance/AccessControl/DoorsManager/DoorsManager'

import FlatFrame from './components/UI/Layout/FlatFrame'
import RealtimeEntries from './components/Vigilance/AccessControl/Monitoring/RealtimeEntries'

import CamerasReviewPage from './components/Vigilance/Cameras/CamerasReview'

// Forecasting
import ForecastingModule from './components/Forecasting/module.vue'
import ForecastingIndex from './components/Forecasting/Index.vue'

const authGuard = async (to, from, next) => {
    // let theState = !!localStorage.getItem('state') ? JSON.parse(LZString.decompress(localStorage.getItem('state'))): null;
    let theState = !!localStorage.getItem('state')
        ? JSON.parse(localStorage.getItem('state'))
        : null

    if (!!theState) {
        store.commit('state', theState)
    }

    let isAuthenticated = store.getters.isAuthenticated
    if (isAuthenticated) return next()

    return next({
        name: 'loginPage',
    })
}

const supervisionClientSelected = (to, from, next) => {
    if (!store.getters.supervisionClient) {
        next({
            name: 'supervisionIndexPage',
        })
    } else {
        next()
    }
}

export const routes = [
    {
        path: '/',
        component: LoginPage,
        name: 'loginPage',
        exact: true,
        beforeEnter: (to, from, next) => {
            localStorage.clear()
            next()
        },
    },
    {
        path: '/client-selection',
        component: ClientSelectionPage,
        name: 'clientSelection',
    },

    {
        path: '/app',
        name: 'app',
        component: App,
        beforeEnter: authGuard,
        children: [
            {
                path: 'forecasting',
                component: ForecastingModule,
                children: [
                    {
                        path: 'index',
                        name: 'forecasting',
                        component: ForecastingIndex,
                    },
                ],
            },
            {
                path: 'vigilance',
                components: {
                    default: VigilancePage,
                    sidebar: VigilanceOptions,
                },
                children: [
                    {
                        path: '',
                        name: 'vigilancePage',
                        component: EntryPage,
                    },
                    {
                        path: 'departures',
                        name: 'departuresPage',
                        component: DeparturesPage,
                    },
                    {
                        path: 'notebook',
                        name: 'notebook',
                        component: NoteBookPage,
                    },
                    {
                        path: 'mail',
                        name: 'mail',
                        component: MailPage,
                    },
                    {
                        path: 'mail-distribution',
                        name: 'mailDistribution',
                        component: MailDistribution,
                    },
                    {
                        path: 'list-people-page',
                        name: 'peoplePageListVigilance',
                        component: ListPeople,
                    },
                    {
                        path: 'list-vehicles-page',
                        name: 'vehiclesPageVigilance',
                        component: vehiclesPage,
                    },
                    {
                        path: 'authorize-entry-person',
                        name: 'authorizeEntryPerson',
                        component: AuthorizeEntryPerson,
                    },
                    {
                        path: 'authorize-entry-person-list',
                        name: 'authorizeEntryPersonList',
                        component: AuthorizeEntryPersonList,
                    },
                    {
                        path: 'load-authorizations',
                        name: 'loadAuthorizations',
                        component: LoadAuthorizations,
                    },
                    {
                        path: 'duties',
                        name: 'dutiesListVigilance',
                        component: DutiesListVigilancePage,
                    },
                    {
                        path: 'guardian-manual',
                        name: 'guardianManualPage',
                        component: GuardianManual,
                    },
                    {
                        path: 'shifts-history',
                        name: 'shiftsHistoryVigilancePage',
                        component: ShiftsHistoryPage,
                    },
                    {
                        path: 'access-control/restricted-visitors',
                        name: 'restrictedVisitors',
                        component: RestrictedVisitorsPage,
                    },
                    {
                        path: 'entry-cargo-vehicle',
                        name: 'cargoVehicleEntriesPage',
                        component: CargoVehicleEntriesPage,
                    },
                    {
                        path: 'departures-cargo-vehicle',
                        name: 'cargoVehicleDeparturesPage',
                        component: CargoVehicleDeparturesPage,
                    },
                    {
                        path: 'bodyguard-services',
                        name: 'bodyguardServicesPage',
                        component: BodyguardServicesPage,
                    },
                    {
                        path: 'active-bodyguard-service',
                        name: 'activeBodyguardServicePage',
                        component: ActiveBodyguardServicePage,
                    },
                    {
                        path: 'notebook-for-bodyguards',
                        name: 'notebookForBodyguards',
                        component: NotebookForBodyguards,
                    },
                    {
                        path: 'bodyguard-page',
                        name: 'bodyguardPage',
                        component: BodyguardPage,
                    },
                    {
                        path: 'rounds-page',
                        name: 'roundsPage',
                        component: RoundsPage,
                    },
                    {
                        path: 'rounds-report-page',
                        name: 'roundsReportPage',
                        component: RoundsReportPage,
                    },
                ],
            },
            {
                path: 'supervision',
                component: SupervisionPage,
                children: [
                    {
                        path: '/',
                        name: 'supervisionIndexPage',
                        component: SupervisionIndexPage,
                    },
                    {
                        path: 'checklist',
                        name: 'supervisionChecklist',
                        component: SupervisionChecklist,
                        beforeEnter: supervisionClientSelected,
                    },
                    {
                        path: 'safety-recomendation',
                        name: 'supervisionSafetyRecommendation',
                        component: SupervisionSafetyRecommendation,
                        beforeEnter: supervisionClientSelected,
                    },
                    {
                        path: 'tools-revision',
                        name: 'supervisionToolsRevision',
                        component: SupervisionToolsRevision,
                        beforeEnter: supervisionClientSelected,
                    },
                    {
                        path: 'notebook',
                        name: 'supervisionNotebook',
                        component: SupervisionNotebook,
                        beforeEnter: supervisionClientSelected,
                    },
                    {
                        path: 'contact-report',
                        name: 'supervisionContactReport',
                        component: SupervisionContactReport,
                        beforeEnter: supervisionClientSelected,
                    },
                    {
                        path: 'old-version-notice',
                        name: 'supervisionOldVersionNotice',
                        component: SupervisionOldVersionNotice,
                    },
                    {
                        path: 'supervision-simulation',
                        name: 'supervisionSimulation',
                        component: SupervisionSimulations,
                    },
                    {
                        path: 'electronic-systems-review',
                        name: 'supervisionCameraReview',
                        component: SupervisionCameraReview,
                    },
                    {
                        path: 'vehicle-states',
                        name: 'supervisionVehicleStateReviews',
                        component: SupervisionVehicleStates,
                    },
                ],
            },
            {
                path: 'shift-start-page',
                name: 'shiftStartPage',
                component: ShiftStartPage,
                props: true,
            },
            {
                path: 'shift-end-page',
                name: 'shiftEndPage',
                component: ShiftEndPage,
            },
            {
                path: '/structure-access',
                component: StructureAccessPage,
                name: 'structureAccess',
            },
            {
                path: 'admin',
                components: {
                    default: AdminPage,
                    sidebar: AdminOptions,
                },
                beforeEnter: authGuard,
                children: [
                    {
                        path: 'admin-welcome',
                        name: 'adminPage',
                        component: AdminWelcomePage,
                    },
                    {
                        path: 'load-structures',
                        name: 'loadStructures',
                        component: LoadStructuresPage,
                    },
                    {
                        path: 'list-structures',
                        name: 'listStructures',
                        component: ListStructuresPage,
                        props: true,
                    },
                    {
                        path: 'list-people/:structureId',
                        name: 'listPeople',
                        component: ListPeoplePage,
                        props: true,
                    },
                    {
                        path: 'list-vehicles/:structureId',
                        name: 'listVehicles',
                        component: ListVehiclesPage,
                        props: true,
                    },
                    {
                        path: 'assignations',
                        name: 'assignations',
                        component: AssignationsPage,
                    },
                    {
                        path: 'user-register-form',
                        name: 'usersFormPage',
                        component: UserPage,
                        props: {
                            myUser: {},
                        },
                    },
                    {
                        path: 'list-users',
                        name: 'listUsers',
                        component: ListUsers,
                    },
                    {
                        path: 'list-clients',
                        name: 'clientsPage',
                        component: ClientsList,
                    },
                    {
                        path: 'user-register-form',
                        name: 'clientForm',
                        component: ClientForm,
                    },
                    {
                        path: 'list-people-page',
                        name: 'peoplePageList',
                        component: ListPeople,
                    },
                    {
                        path: 'vigilant-access',
                        name: 'vigilantAccess',
                        component: VigilantAccess,
                    },
                    {
                        path: 'person-register-form',
                        name: 'personForm',
                        component: PeopleForm,
                    },
                    {
                        path: 'vehicle-register-form',
                        name: 'vehicleForm',
                        component: vehicleForm,
                    },
                    {
                        path: 'list-vehicles-page',
                        name: 'vehiclesPage',
                        component: vehiclesPage,
                    },
                    {
                        path: 'list-duties-page',
                        name: 'dutiesPage',
                        component: DutiesListPage,
                    },
                    {
                        path: 'positions',
                        name: 'positionsPage',
                        component: PositionsPage,
                    },
                    {
                        path: 'notebook-by-client',
                        name: 'clientsNotebookPage',
                        component: ClientsNotebookPage,
                    },
                    {
                        path: 'mails-by-client',
                        name: 'clientsMailsPage',
                        component: ClientsMailsPage,
                    },
                    {
                        path: 'visitors-by-client',
                        name: 'clientsVisitorsPage',
                        component: ClientsVisitorsPage,
                    },
                    {
                        path: 'security-manager',
                        name: 'securityManager',
                        component: SecurityManager,
                    },
                    {
                        path: 'menu-options',
                        name: 'menuOptionsPage',
                        component: MenuOptionsPage,
                    },
                    {
                        path: 'shifts-history',
                        name: 'shiftsHistoryPage',
                        component: ShiftsHistoryPage,
                    },
                    {
                        path: 'client-contacts/:clientId',
                        name: 'clientContactsPage',
                        component: ClientContactsPage,
                        props: true,
                    },
                    {
                        path: 'client-prospect/:clientId',
                        name: 'ClientProspectForm',
                        component: ClientProspectForm,
                        props: true,
                    },
                    {
                        path: 'client-contacts/:clientId/contact',
                        name: 'contactForm',
                        component: ContactForm,
                        props: true,
                    },
                    // { path: 'client-contacts/:clientId/report', name: 'contactReportForm', component: ContactReportForm, props: true},
                    {
                        path: 'client-contacts/:clientId/report',
                        name: 'contactReportForm',
                        component: NewContactReportPage,
                        props: true,
                    },
                    {
                        path: 'alert-notifications',
                        name: 'alertNotifications',
                        component: AlertNotificationsPage,
                    },
                    {
                        path: 'pets',
                        name: 'pets',
                        component: PetPage,
                    },
                ],
            },
            {
                path: 'logistics',
                components: {
                    default: LogisticsPage,
                    sidebar: LogisticsOptions,
                },
                children: [
                    {
                        path: 'items',
                        name: 'itemsPage',
                        component: ItemsPage,
                    },
                    {
                        path: 'items-types',
                        name: 'itemTypesPage',
                        component: ItemTypesPage,
                    },
                    {
                        path: 'assign-item-to-the-client',
                        name: 'assignItemToTheClientPage',
                        component: AssignToolToTheClientPage,
                    },
                    {
                        path: 'item-sub-types',
                        name: 'itemSubTypes',
                        component: ItemSubTypes,
                    },
                    {
                        path: 'formats',
                        name: 'formatsPage',
                        component: FormatsPage,
                    },
                    {
                        path: 'format-create',
                        name: 'formatCreate',
                        component: FormatCreate,
                    },
                    {
                        path: 'format-detail-list',
                        name: 'formatDetailList',
                        component: FormatDetailList,
                        props: true,
                    },
                    {
                        path: 'format-detail',
                        name: 'formatDetail',
                        component: FormatDetail,
                        props: true,
                    },
                    {
                        path: 'format-register',
                        name: 'formatRegister',
                        component: FormatRegister,
                        props: true,
                    },
                ],
            },
            {
                path: 'account',
                components: {
                    default: AccountPage,
                    sidebar: AccountOptions,
                },
                beforeEnter: authGuard,
                children: [
                    {
                        path: 'account-welcome',
                        name: 'accountPage',
                        component: AccountWelcomePage,
                    },
                    {
                        path: 'signature',
                        name: 'accountSignature',
                        component: AccountSignaturePage,
                    },
                    {
                        path: 'change-password',
                        name: 'changePassword',
                        component: ChangePassword,
                    },
                ],
            },

            {
                path: '/general-status',
                name: 'generalStatus',
                component: GeneralStatusPage,
            },
            {
                path: '/client-config',
                name: 'clientConfigPage',
                components: {
                    default: ClientConfigPage,
                    sidebar: ClientConfigOptions,
                },
                children: [
                    {
                        path: 'entry-times',
                        name: 'clientEntryTimes',
                        component: EntryTimesPage,
                    },
                ],
            },
            {
                path: 'admin-clients',
                components: {
                    default: AdminClientsPage,
                    sidebar: AdminClientsOptions,
                },
                children: [
                    {
                        path: '/admin-clients-welcome',
                        name: 'adminClients',
                        component: AdminClientsWelcome,
                    },
                    {
                        path: '/person-visitors',
                        name: 'personVisitors',
                        component: PersonVisitors,
                    },
                    {
                        path: '/vehicle-visitors',
                        name: 'vehicleVisitors',
                        component: VehicleVisitors,
                    },
                    {
                        path: '/pqr',
                        name: 'PqrPage',
                        component: PqrPage,
                    },
                    {
                        path: 'list-duties-client-page',
                        name: 'dutiesAdminClientPage',
                        component: DutiesListVigilancePage,
                    },
                    {
                        path: 'notebook',
                        name: 'notebookAdminClient',
                        component: NoteBookPage,
                    },
                    {
                        path: 'list-structures',
                        name: 'listStructuresAdminClient',
                        component: ListStructuresPage,
                        props: true,
                    },
                    {
                        path: 'list-people/:structureId',
                        name: 'listPeopleAdminClient',
                        component: ListPeoplePage,
                        props: true,
                    },
                    {
                        path: 'list-vehicles/:structureId',
                        name: 'listVehiclesAdminClient',
                        component: ListVehiclesPage,
                        props: true,
                    },
                    {
                        path: 'authorize-entry-person-list',
                        name: 'authorizeEntryPersonListAdminClient',
                        component: AuthorizeEntryPersonList,
                    },
                    // { path: 'reporting/dashboard', name: 'reportingDashboard', component: DashboardPage },
                    {
                        path: 'list-vehicles-page',
                        name: 'vehiclesPageClient',
                        component: vehiclesPage,
                    },
                    {
                        path: 'list-people-page',
                        name: 'peoplePageListClient',
                        component: ListPeople,
                    },
                    {
                        path: 'client-areas',
                        name: 'clientAreasPage',
                        component: ClientAreasPage,
                    },
                    {
                        path: 'data-consent',
                        name: 'clientDataConsentPage',
                        component: ClientDataConsentPage,
                    },
                    {
                        path: 'incident-risk-types',
                        name: 'incidentRiskTypesPage',
                        component: IncidentRiskTypesPage,
                    },
                    {
                        path: 'contractor-document-types',
                        name: 'contractorDocumentTypesPage',
                        component: ContractorDocumentTypesPage,
                    },
                    {
                        path: 'contractor-management',
                        name: 'contractorManagementPage',
                        component: ContractorManagementPage,
                    },
                    {
                        path: 'pending-activations',
                        name: 'pendingActivationsPage',
                        component: PendingActivationsPage,
                    },
                    {
                        path: 'risk-analysis',
                        name: 'riskAnalysisClient',
                        component: RiskAnalysisClient,
                    },
                    {
                        path: 'broadcast-messages',
                        name: 'clientBroadcastMessages',
                        component: BroadcastMessagesPage,
                    },
                    {
                        path: 'client-users',
                        name: 'clientUsersPage',
                        component: ClientUsersPage,
                    },
                    {
                        path: 'bodyguard-services',
                        name: 'bodyguardServicesAdminClient',
                        component: BodyguardServiceAdminClient,
                    },
                    {
                        path: 'cargo-vehicle-entries',
                        name: 'cargoVehicleEntries',
                        component: CargoVehicleEntriesPage,
                    },
                    {
                        path: 'client-file-management',
                        name: 'FileManagement',
                        component: fileManagementPage,
                    },
                    {
                        path: 'mails-review',
                        name: 'clientMailsReview',
                        component: ClientMailsReview,
                    },
                    {
                        path: 'risk-diagnosis',
                        name: 'riskDiagnosis',
                        component: RiskDiagnosisDocumentationPage,
                    },
                    {
                        path: 'door-management',
                        name: 'doorsManagement',
                        component: DoorsManager,
                    },
                ],
            },
            {
                path: 'contractor',
                components: {
                    default: ContractorPage,
                    sidebar: ContractorOptions,
                },
                redirect: { name: 'contractorDocumentsPage' },
                children: [
                    {
                        path: 'documents',
                        name: 'contractorDocumentsPage',
                        component: ContractorDocumentsPage,
                    },
                ],
            },
            {
                path: 'reporting',
                component: ReportingPage,
                children: [
                    {
                        path: 'client',
                        component: ClientReportingPage,
                        children: [
                            {
                                path: 'dashboard',
                                name: 'reportingDashboard',
                                component: DashboardPage,
                            },
                        ],
                    },
                    {
                        path: 'company',
                        component: CompanyReportingPage,
                        children: [
                            {
                                path: 'operation-dashboard',
                                name: 'operationDashboard',
                                component: ClientDashboardPage,
                            },
                            {
                                path: 'internal-management',
                                name: 'internalManagementPage',
                                component: InternalManagementPage,
                            },
                            {
                                path: 'monthly-management-report',
                                name: 'monthlyManagementReportPage',
                                component: MonthlyManagementReportPage,
                            },
                            {
                                path: 'adoption',
                                name: 'adoptionReportPage',
                                component: AdoptionReportPage,
                            },
                            {
                                path: 'pqrs',
                                name: 'pqrsReportPage',
                                component: PqrsReportingPage,
                            },
                            {
                                path: 'operational-indicators',
                                name: 'operationalIdicatorsPage',
                                component: OperationalIdicators,
                            },
                            {
                                path: 'management-indicators',
                                name: 'managementIdicatorsPage',
                                component: ManagementIndicatorsIndex,
                            },
                            {
                                path: 'client-satisfaction',
                                name: 'clientSatisfactionReport',
                                component: SatisfactionReport,
                            },
                            {
                                path: 'clients-implementation',
                                name: 'clientsImplementationReport',
                                component: ClientsImplementationReport,
                            },
                            {
                                path: 'rounds-review',
                                name: 'roundsReviewPage',
                                component: RoundsReviewPage,
                            },
                            {
                                path: 'management-dashboards',
                                component: ManagementDashboardsModule,
                                children: [
                                    {
                                        path: 'supervision-checklist-dashboard',
                                        name: 'managementDashboards',
                                        component:
                                            SupervisionChecklistDashboard,
                                    },
                                    {
                                        path: 'management-indicators',
                                        name: 'managementIndicators',
                                        component:
                                            ManagementIndicatorsDashboard,
                                    },
                                ],
                            },
                        ],
                    },
                    {
                        path: 'vigilance/cameras-review',
                        name: 'camerasReviewPage',
                        component: CamerasReviewPage,
                    },
                ],
            },
            {
                path: 'administrative',
                components: {
                    default: AdministrativePage,
                    sidebar: AdministrativeMenu,
                },
                children: [
                    {
                        path: 'welcome',
                        name: 'administrativeArea',
                        component: AdministrativePageWelcome,
                    },
                    {
                        path: 'assigned-petitions',
                        name: 'assignedPetitions',
                        component: AssignedPetitionsList,
                    },
                    {
                        path: 'unassigned-petitions',
                        name: 'unassignedPetitions',
                        component: UnassignedPetitionsList,
                    },
                    {
                        path: 'resolved-petitions',
                        name: 'resolvedPetitions',
                        component: ResolvedPetitionsList,
                    },
                    {
                        path: 'my-tasks-list',
                        name: 'myTasksList',
                        component: MyTasksList,
                    },
                    {
                        path: 'resolved-petitions-by-administrative',
                        name: 'resolvedPetitionsByAdministrative',
                        component: ResolvedPetitions,
                    },
                    {
                        path: 'approval-duties',
                        name: 'approvalDuties',
                        component: ApprovalDutiesPage,
                    },
                    {
                        path: 'assignment-duties-to-the-client',
                        name: 'assignmentDuties',
                        component: AssignmentDutiesPage,
                    },
                    {
                        path: 'assignment-task',
                        name: 'assignmentTask',
                        component: AssignmentTaskPage,
                    },
                    {
                        path: 'assigned-tasks',
                        name: 'assignedTasks',
                        component: AssignedTaskPage,
                    },
                    {
                        path: 'resolved-tasks',
                        name: 'resolvedTasks',
                        component: ResolvedTasksPage,
                    },
                    {
                        path: 'tasks-to-observe',
                        name: 'tasksToObserve',
                        component: TasksToObservePage,
                    },
                    {
                        path: 'open-tasks',
                        name: 'openTasks',
                        component: OpenTasksPage,
                    },
                    {
                        path: 'created-tasks-resolved',
                        name: 'createdTasksResolved',
                        component: CreatedTasksResolvedPage,
                    },
                    {
                        path: 'supervision-notebook',
                        name: 'notebookOfSupervisors',
                        component: NotebookOfSupervisors,
                    },
                    {
                        path: 'supervision-checklists',
                        name: 'supervisionChecklists',
                        component: SupervisionReview,
                    },
                    {
                        path: 'client-mail-review',
                        name: 'clientMailReview',
                        component: ClientMailReview,
                    },
                    {
                        path: 'restricted-visitors',
                        name: 'restrictedVisitorsAdministrative',
                        component: RestrictedVisitorsPage,
                    },
                    {
                        path: 'users-pending-activation',
                        name: 'usersPendingActivationPage',
                        component: UsersPendingActivationPage,
                    },
                    {
                        path: 'safety-recommendations',
                        name: 'safetyRecommendations',
                        component: SafetyRecommendations,
                    },
                    {
                        path: 'contact-reports-review',
                        name: 'contactReportsReviewPage',
                        component: ContactReportsReviewPage,
                    },
                    {
                        path: 'petitions-review',
                        name: 'petitionsReviewPage',
                        component: PetitionsReviewPage,
                    },
                    {
                        path: 'team-petitions',
                        name: 'teamPetitionsPage',
                        component: TeamPetitionsPage,
                    },
                    {
                        path: 'company-broadcast-message',
                        name: 'companyBroadcastMessages',
                        component: CompanyBroadcastMessage,
                    },
                    {
                        path: 'stores',
                        name: 'storesPage',
                        component: StoresPage,
                    },
                    {
                        path: 'admin-store',
                        name: 'adminStore',
                        component: AdminStore,
                    },
                    {
                        path: 'bodyguard-services',
                        name: 'bodyguardServicesAdministrative',
                        component: BodyguardServicesAdministrative,
                    },
                    {
                        path: 'performance-evaluation',
                        name: 'performanceEvaluation',
                        component: PerformanceEvaluationPage,
                    },
                    {
                        path: 'open-performance-evaluation',
                        name: 'openPerformanceEvaluation',
                        component: OpenPerformanceEvaluationPage,
                    },
                    {
                        path: 'evaluation-page',
                        name: 'evaluationPage',
                        component: EvaluationPage,
                    },
                    {
                        path: 'my-evaluations-page',
                        name: 'myEvaluationsPage',
                        component: MyEvaluationsPage,
                    },
                    {
                        path: 'performance-evaluation-operative',
                        name: 'performanceEvaluationOperative',
                        component: PerformanceEvaluationOperativePage,
                    },
                ],
            },
            {
                path: 'documentation',
                name: 'documentation',
                component: DocumentationPage,
            },
            {
                path: 'support',
                component: SupportPage,
                children: [
                    {
                        path: '/',
                        name: 'support',
                        component: MyTicketsPage,
                    },
                ],
            },
            {
                path: 'support-attention',
                component: AttentionPage,
                children: [
                    {
                        path: '/',
                        name: 'tickets',
                        component: TicketsPage,
                    },
                ],
            },
            {
                path: 'comunications',
                component: ComunicationsModule,
                children: [
                    {
                        path: 'service-spot-messages',
                        component: ServiceSpotMessagesPage,
                        name: 'serviceSpotMessages',
                    },
                    {
                        path: 'service-spot-messages/send',
                        component: ServiceSpotMessagesSendPage,
                        name: 'serviceSpotMessagesSend',
                    },
                ],
            },
            {
                path: 'protocols',
                component: ProtocolsModule,
                children: [
                    {
                        path: 'covid-19',
                        component: Covid19,
                        name: 'covidProtocol',
                    },
                ],
            },
            {
                path: 'quality',
                component: QualityModule,
                children: [
                    {
                        path: 'processes',
                        name: 'quality',
                        component: ProcessesPage,
                    },
                    {
                        path: 'processes/folders',
                        name: 'documentTypes',
                        component: DocumentTypesPage,
                    },
                    {
                        path: 'processes/folders/documents',
                        name: 'qualityDocuments',
                        component: DocumentsPage,
                    },
                ],
            },
            {
                path: 'operation',
                components: {
                    default: OperationPage,
                    sidebar: OperationOptions,
                },
                children: [
                    {
                        path: 'quotations',
                        name: 'quotationsPage',
                        component: QuotationsPage,
                    },
                    {
                        path: 'quotations/create',
                        name: 'quotationCreatePage',
                        component: QuotationCreatePage,
                    },
                    {
                        path: 'quotations/edit/:id',
                        name: 'quotationEditPage',
                        component: QuotationEditPage,
                    },
                    {
                        path: 'quotations/view/:id',
                        name: 'quotationViewPage',
                        component: QuotationViewPage,
                    },
                    {
                        path: 'quotations/history/:id',
                        name: 'quotationHistoryPage',
                        component: QuotationHistoryPage,
                    },
                    {
                        path: 'items',
                        name: 'itemsQuotationPage',
                        component: ItemsQuotationPage,
                    },
                    {
                        path: 'quotation-settings',
                        name: 'quotationSettingsPage',
                        component: QuotationSettingsPage,
                    },
                    {
                        path: 'kits',
                        name: 'kitsPage',
                        component: KitsPage,
                    },
                ],
            },
        ],
    },
    {
        path: '/tests',
        name: 'tests',
        component: CameraPage,
    },
    {
        path: '/flat',
        component: FlatFrame,
        children: [
            {
                path: '/realtime-entries',
                name: 'realtimeEntries',
                component: RealtimeEntries,
            },
        ],
    },
]
